// IMPORT
const THREE = require('three')
import store from 'src/store'
import {getDistanceForPerfectProjection} from './utils'



// CAMERA
export let camera = new THREE.PerspectiveCamera(
  60,
  window.innerWidth / window.innerHeight,
  0.01,
  100000
)
export default camera
export let perfectZ = getDistanceForPerfectProjection()
camera.position.z = perfectZ



// RESIZE
const updateAspect = function () {
  camera.aspect = store.state.browser.windowWidth / store.state.browser.windowHeight
  camera.updateProjectionMatrix()

  perfectZ = getDistanceForPerfectProjection()
  camera.position.z = perfectZ
}
store.watch(function (state) {
  return store.state.browser.windowWidth
}, updateAspect)
store.watch(function (state) {
  return store.state.browser.windowHeight
}, updateAspect)









// WEBPACK FOOTER //
// ./src/components/game/camera-ui.js